<template>
  <div id="msg-div">
    <v-card
      color="#eeeeee"
      elevation="0"
      v-if="$store.state.messanger_type_selected === undefined"
      class="center"
    >
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <span class="font-weight-black subtitle-1">
            Select messaging dashboard context :
          </span>
        </v-col>
        <v-col
          cols="auto"
          v-for="(item, index) in $store.state.messangerItems"
          :key="index"
        >
          <v-btn
            dark
            color="cleed_blue"
            width="200px"
            @click="select_messanger_type(index)"
            large
          >
            <cleed-icon class="mr-3" :icon="item.icon" />

            <b>{{ $t(`drawer.contexts.${item.mode}`) }}</b>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card color="#eeeeee" elevation="0" v-else>
      <v-toolbar
        v-if="$store.state.show.chat && !$store.state.show.videoChat"
        dense
        class="grey--text text--darken-1 elevation-0"
      >
        <v-app-bar-nav-icon>
          <v-tooltip color="black" right>
            <template v-slot:activator="{ on }">
              <v-app-bar-nav-icon class="ml-1" icon @click="out()" v-on="on">
                <v-icon color="black" size="28"> mdi-chevron-left </v-icon>
              </v-app-bar-nav-icon>
            </template>
            <span> {{ $t("messanger.chat.back") }} </span>
          </v-tooltip>
        </v-app-bar-nav-icon>

        <v-spacer></v-spacer>

        <v-toolbar-title v-if="$store.state.chat_user.receiver_id">
          <div class="title-chat">
            <v-badge
              :color="
                $store.state.online_users.includes(
                  $store.state.chat_user.guid.toString()
                )
                  ? 'green'
                  : 'pink'
              "
              dot
              class="ma-1 mr-2"
              left
            />
            {{ $t("messanger.chat.user") }}
            {{
              $store.state.chat_user.firstname ||
              $store.state.chat_user.email ||
              $store.state.chat_user.contact ||
              `#${$store.state.chat_user.id}`
            }}
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip left color="black">
          <template v-slot:activator="{ on }">
            <v-btn
              color="black"
              icon
              @click="VideoCallBtn()"
              v-on="on"
              :loading="video_check_loading"
            >
              <v-icon size="25"> mdi-video </v-icon>
            </v-btn>
          </template>
          <span> Video chat </span>
        </v-tooltip>

        <SendByMail />

        <v-tooltip left color="black">
          <template v-slot:activator="{ on }">
            <v-btn color="black" icon @click="info()" v-on="on">
              <v-icon size="25"> mdi-badge-account-horizontal-outline </v-icon>
            </v-btn>
          </template>
          <span> {{ $t("messanger.chat.user_info") }} </span>
        </v-tooltip>

        <ConversationOptions :item="$store.state.chat_user" />
      </v-toolbar>
      <ContextFilters
        v-if="$store.state.show.chat"
        @selectNewContext="convesationChangeContext"
      />
      <v-card v-if="$store.state.show.chat" color="#eeeeee" elevation="0">
        <div v-if="$store.state.show.videoChat">
          <videoCall />
        </div>
        <div
          v-else
          class="chat-content"
          style="scroll-behavior: smooth; min-height: 100vh !important"
        >
          <Message :context="context" />
        </div>
      </v-card>
      <v-card v-if="$store.state.show.dash" color="#eeeeee" elevation="0">
        <v-container fluid class="mb-10 no-gutters">
          <MsgDash />
        </v-container>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import MsgDash from "@/components/messenger/Msg-dash";
import Message from "@/components/messenger/Message";
import ConversationOptions from "@/components/messenger/Conversation_options";
import SendByMail from "@/components/messenger/MessageFormats/SendByMail";
import CleedIcon from "@/components/core/CleedIcon";
import ContextFilters from "@/components/messenger/MessageDashFiles/ContextFilters.vue";
import videoCall from "../components/messenger/Video/VideoCall.vue";

export default {
  components: {
    MsgDash,
    Message,
    ConversationOptions,
    SendByMail,
    CleedIcon,
    ContextFilters,
    videoCall,
  },
  data: () => ({
    mobile: false,
    snackbar: true,
    temp: "",
    right: false,
    msg_cmp: 1,
    user: "",
    context: "",
    video_check_loading: false,
  }),
  mounted() {
    //
  },
  destroyed() {
    /** ---------------------- destroy the message type selected------------------------------*/
    this.$store.state.messanger_type_selected = undefined;
    /** ----------------------------------------------------------------------------------------*/

    /** ---------------------- destroy the globaSelector if exist------------------------------*/
    this.$store.dispatch("selector/select", {
      active: false,
    });
    const obj = {
      user: this.$store.state.chat_user.guid,
      store: this.$store.state.store.store.store_id,
    };
    this.$socket.emit("DestroyRoom", obj);
    /** ----------------------------------------------------------------------------------------*/
  },
  methods: {
    check_UserMedia(options) {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia(options)
          .then((stream) => {
            resolve(stream);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async VideoCallBtn() {
      console.log("calling");
      this.video_check_loading = true;
      await this.check_UserMedia({ video: true, audio: true })
        .then((stream) => {
          this.$socket.emit(
            "VIDEO_CHAT_AdminJoinRoom",
            this.$store.state.chat_user.guid
          );
          this.video_check_loading = false;
          this.$store.state.show.videoChat = true;
          this.$store.state.show.callOverlay = true;
          this.$store.dispatch("enableCallSound", "play");
          this.$store.state.videoChat = {
            call: undefined,
            peerId: undefined,
            myPeer: undefined,
            remoteStreamMedia: {
              audio: true,
              video: true,
            },
            showConversation: false,
            messages: [],
            messageNotif: false,
            socketAddr: undefined,
            RefVideoChatContent: null,
          };
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: `Permission denied please give access to the camera and microphone`,
            color: "error",
            timeout: 5000,
          });
          console.log(err);
          this.video_check_loading = false;
        });
    },
    show() {
      this.$store.state.show.dash = !this.$store.state.show.dash;
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    },
    status_set(status) {
      if (status === "Solved") {
        return { color: "#008000", value: "Solved" };
      } else if (status === "Solved (Email)") {
        return { color: "#008000", value: "Solved (Email)" };
      } else if (status === "To check") {
        return { color: "error darken-1", value: "To check" };
      } else if (status === "To check sto") {
        return { color: "error darken-1", value: "To check sto" };
      } else if (status === "By email") {
        return { color: "red darken-2", value: "By email" };
      } else if (status === "Answered") {
        return { color: "#65ff00", value: "Answered" };
      } else if (status === "To answer") {
        return { color: "red darken-1", value: "To answer" };
      }
    },
    last_message(item) {
      let ls = "";
      if (typeof item === "object") {
        if (Object.keys(item).includes("carousel") && item.carousel)
          ls = { key: "Carousel" };
        else if (Object.keys(item).includes("attachment") && item.attachment)
          ls = { key: "Attachment" };
        else if (Object.keys(item).includes("look") && item.look)
          ls = { key: "Look" };
        else if (Object.keys(item).includes("form") && item.form)
          ls = `From of ${item.message.split(".")[0]}`;
        else if (Object.keys(item).includes("buttons") && item.buttons)
          ls = `${item.message.split(".")[0]} Selection`;
        else if (Object.keys(item).includes("grid") && item.grid)
          ls = { key: "Grid" };
        else if (Object.keys(item).includes("brands") && item.brands)
          ls = { key: "Brands" };
        else ls = item.message;
      } else ls = item;
      return ls;
    },
    out() {
      // and new changes to dash on click on the go back btn
      if (
        this.$store.state.messages.messages.length !==
        this.$store.state.messages.messages_length
      ) {
        const index = this.$store.state.messages.filter_rest.findIndex(
          (x) => x.guid === this.$store.state.chat_user.guid
        );
        if (index > -1) {
          let newMsg = this.$store.state.messages.messages[
            this.$store.state.messages.messages.length - 1
          ];
          this.$store.state.messages.filter_rest[
            index
          ].last_message = this.last_message(newMsg.content);
          this.$store.state.messages.filter_rest[index].sender_type =
            newMsg.sender_type;
          this.$store.state.messages.filter_rest[index].waiting =
            newMsg.waiting;
          this.$store.state.messages.filter_rest[index].sent_at =
            newMsg.send_time;
          let temp = this.$store.state.messages.filter_rest[index];

          this.remove(this.$store.state.messages.filter_rest, temp);
          this.$store.state.messages.filter_rest.splice(0, 0, temp);
          this.$store.state.messages.new_msg = false;
        }
      }

      this.$store.state.show.dash = true;
      this.$store.state.chat_user = "";
      this.$store.state.save_status = "";
      this.$store.state.messages.messages = [];
      this.$store.state.show.chat = false;
    },
    info() {
      this.user = this.$store.state.chat_user;
      //console.log("=>", this.user);
      this.$store.state.show.dash = false;
      this.$store.state.show.chat = false;
      this.$store
        .dispatch("FETCH_USER", this.user.receiver_id)
        .then((response) => {
          this.$store.dispatch("setInfocard", {
            showing: true,
            id: this.user.receiver_id,
            user: this.user,
            from: "message",
          });
        });
    },
    select_messanger_type(i) {
      console.log("click", i);
      this.$store.state.messanger_type_selected = i;
      this.$store.state.link = {
        to: "/messages",
        icon: "mdi-email",
        text: "Messenger",
      };
      if (this.$store.state.messanger_type_selected !== undefined) {
        this.$store.state.messages.loading = true;
      }
    },
    convesationChangeContext(e) {
      this.context = e;
    },
  },
};
</script>
<style scoped>
.title-chat {
  font-size: 1rem;
  -webkit-transition: height 160ms ease-out 0s;
  transition: height 160ms ease-out 0s;
  margin: 6px;
}
#my-div {
  height: 100vh;
}
.center {
  margin: auto;
  width: 100%;
  position: absolute;
  top: 40%;
  align-content: center;
}
</style>
